import React from 'react';
import {Link} from "react-router-dom";
import '../App.css';
import bready from '../images/bready.png';
import ReactGoogleSlides from "react-google-slides";

function Interviews(props) {
  return (
    <div className="caseify">
      <div><Link to="/" id="back">(back)</Link></div>
      <div> </div>
      <div id="title">timidxtalk - Design Interviews Told by an Introvert</div>
      <img src={bready} alt="get bready for design interviews banner"/>
      <div id="table">
        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">About</div>
            <div id="casetext">A guest lecture that dissects my design internship interview and what I would do differently.</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Topics</div>
            <div id="casetext">Design interviews, case studies, building confidence, public speaking, introversion</div>
          </div>
        </div>
        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">Audience</div>
            <div id="casetext">COGS 127 design students, anyone who is intimidated by interviews</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Timeline</div>
            <div id="casetext">February 2023</div>
          </div>
        </div>
         <div id="tablerow">
            <div id="casetitle">Context</div>
            <div id="casetext">I didn’t think there was any advice less resonating than “imagine everyone naked,” but I struggled with the idea that I had to 'overcome' my shyness and social anxiety 
            to be on par with my naturally confident and sociable peers. It’s true that I get nervous, but I also get excited when I share something I care about like design concepts and food recommendations. When I didn’t reduce myself to perceived weaknesses, I could navigate interviews - and the world - in a 
            way that allows me to be myself. I wish I could tell this to my past self, and in some ways, I could fulfill that dream with a guest lecture for the class I once took.</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Goals</div>
            <div id="casetext">Give students visibility into the design interview process, so it feels less daunting. Encourage students to embrace their strengths in a way that values their 
            uniqueness.</div>
          </div>
          <div id="tablerow">
            <div id="casetitle">Impact</div>
            <div id="casetext">Post-lecture, the messages from students reminded me that I can support the design community by sharing my stories as someone who survived the interview process. You wouldn't expect to get public speaking tips from an introvert, but 
            I want to change the narrative of who is ‘qualified’ to give advice about these kinds of topics. Wouldn’t someone who struggled and dedicated time to grow have an equally valuable perspective? Thanks for coming to my Tedxtalk. Or timidxtalk.</div>
          </div>
        
      </div>

      <p>.・。.・゜✭・.・✫・゜・。.</p>

      <div>
        <ReactGoogleSlides
          width="100%"
          slidesLink="https://docs.google.com/presentation/d/1XsrJhZ_YNFgtVEXWcmp8QtnJQdATF3fKcGqMu85Og0M/edit?usp=sharing"
        />
      </div>

      <p>.・。.・゜✭・.・✫・゜・。.</p>

    </div>
  );
}

export default Interviews;

